module.exports = __webpack_public_path__ + "static/demarcus-robinson-1cc02f479b6faa274456a64dfa9e6d14.jpg";